<div class="card observacao-container">
    <p-toolbar styleClass="mb-4 observacao-toolbar">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Novo" [disabled]="permissaoService.can('sensores_inserir') == false"
                icon="pi pi-plus" class="p-button-success mr-2" (click)="openNew()"></button>
        </ng-template>

        <!-- <ng-template pTemplate="right">
            <div class="flex">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </div>
        </ng-template> -->
    </p-toolbar>

    <div class="observacao-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id','descricao','pessoa' ]"
            [scrollable]="true" [scrollHeight]="scrollHeight">


        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Observações</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Código
                </th>
                <th>Descrição
                </th>
                <th>Pessoa
                </th>

                <th>Editar</th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>

                <td><span class="p-column-title negrito">Descrição: </span>{{dt.descricao}}</td>
                <td><span class="p-column-title negrito">Pessoa: </span>{{dt.pessoa}}</td>


                <td style="text-align: center;">
                    <span class="p-column-title negrito">Editar: </span>
                    <button pButton pRipple [disabled]="permissaoService.can('sensores_editar') == false"
                        icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        (click)="edit(dt)"></button>
                </td>



            </tr>
        </ng-template>

        </p-table>
    </div>
</div>


<p-dialog header="Observação" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="descricao" pInputText formControlName="descricao">
                    <label for="descricao">Descrição</label>
                </p-floatlabel>
            </div>
            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <p-dropdown inputId="pessoa_id" appendTo="body" [filter]="true" [options]="dropDownPessoa"
                        formControlName="pessoa_id">
                    </p-dropdown>
                    <label for="pessoa_id">Pessoa</label>
                </p-floatlabel>
            </div>

        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>
